import { render, staticRenderFns } from "./ModalEditChannels.vue?vue&type=template&id=e43f4e60"
import script from "./ModalEditChannels.vue?vue&type=script&lang=js"
export * from "./ModalEditChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports